import authAxios from 'src/modules/shared/axios/authAxios';

export default class AffirmationProgramEntitlementService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const response = await authAxios.put(
      `/affirmation-program-entitlement/${id}`,
      body,
    );

    return response.data;
  }

  static async destroyAll(ids) {
    const params = {
      ids,
    };

    const response = await authAxios.delete(
      `/affirmation-program-entitlement`,
      {
        params,
      },
    );

    return response.data;
  }

  static async unarchiveAll(ids) {
    const body = {
      ids,
    };

    const response = await authAxios.put(
      `/affirmation-program-entitlement/unarchive`,
      body,
    );

    return response.data;
  }

  static async create(data) {
    const body = {
      data,
    };

    const response = await authAxios.post(
      `/affirmation-program-entitlement`,
      body,
    );

    return response.data;
  }

  static async import(values, importHash) {
    const body = {
      data: values,
      importHash,
    };

    const response = await authAxios.post(
      `/affirmation-program-entitlement/import`,
      body,
    );

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(
      `/affirmation-program-entitlement/${id}`,
    );

    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(
      `/affirmation-program-entitlement`,
      {
        params,
      },
    );

    return response.data;
  }

  static async listAutocomplete(
    affirmationProgram,
    query,
    limit,
  ) {
    const params = {
      affirmationProgram,
      query,
      limit,
    };

    const response = await authAxios.get(
      `/affirmation-program-entitlement/autocomplete`,
      {
        params,
      },
    );

    return response.data;
  }
}
